export default "__VITE_ASSET__3fBerUyR__"